import { call, put, takeLatest } from 'redux-saga/effects';
import DeviceAction, { DeviceTypes } from "redux/actions/deviceAction";
import DeviceServices from 'services/devicesServices';
import { getTicketDetail } from 'services/ticketServices';
import UserService from 'services/userServices';
import BaseAction from '../actions/baseAction';

export function* getListCardDevice(action: any): any {
  try {
    const result = yield call(DeviceServices.getPCResfreshStatus, action.userName);
    yield put(DeviceAction.getListCardDeviceSuccess(result));
  } catch (error) {
    yield put(DeviceAction.getListCardDeviceFail());
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_CARD_DEVICE ${error}`
    }));
  }
}

export function* checkDXCGear(action: any): any {
  const { email, country, userType } = action;

  try {
    const result = yield call(UserService.checkUserDxcGear, email, country, userType);
    if (result.status === 200) {
      yield put(DeviceAction.checkUserDxcGearSuccess(result?.data.results));
    }
  } catch (error) {
    yield put(DeviceAction.checkUserDxcGearFail());
    yield put(BaseAction.errorHandling({
      message: `CHECK_USER_DXC_GEAR ${error}`
    }));
  }
}

export function* getDataTicketDetail(action: any): any {
  const { isTicket, params } = action;

  try {
    const result = yield call(getTicketDetail, isTicket, params);
    if (result.status === 200) {
      yield put(DeviceAction.getDataTicketDetailSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_DATA_TICKET_DETAIL ${error}`
    }));
  }
}

export function* getNewDeviceAssetRequests(action: any): any {
  try {
    const result = yield call(DeviceServices.getMyNewDeviceAssetRequests, action.userName);
    yield put(DeviceAction.getNewDeviceAssetRequestsSuccess(result));
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_NEW_DEVICE_ASSET_REQUESTS ${error}`
    }));
  }
}

export function* getListVirtualDesktop(action: any): any {
  try {
    const result = yield call(DeviceServices.getListVirtual, action.email);
    yield put(DeviceAction.getListVirtualDesktopSuccess(result));
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_VIRTUAL_DESKTOP ${error}`
    }))
  }
}

export const watchDevice = [
  takeLatest(DeviceTypes.GET_LIST_CARD_DEVICE, getListCardDevice),
  takeLatest(DeviceTypes.CHECK_USER_DXC_GEAR, checkDXCGear),
  takeLatest(DeviceTypes.GET_DATA_TICKET_DETAIL, getDataTicketDetail),
  takeLatest(DeviceTypes.GET_NEW_DEVICE_ASSET_REQUESTS, getNewDeviceAssetRequests),
  takeLatest(DeviceTypes.GET_LIST_VIRTUAL_DESKTOP, getListVirtualDesktop),
]
